import {memo, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import env from "shared/env"
import Link from "@kaspernj/api-maker/build/link"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"
import {StyleSheet} from "react-native"

const styles = StyleSheet.create({
  rootContainer: {
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    paddingTop: 64,
    paddingBottom: 64,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center"
  },
  contentContainer: {
    maxWidth: 640,
    width: "100%",
    alignItems: "center"
  },
  contentBlock: {
    marginBottom: 32,
    alignItems: "center"
  },
  buttonContainer: {
    marginTop: 8
  },
  button: {
    backgroundColor: "#2c2c96",
    borderRadius: 30,
    paddingVertical: 14,
    paddingHorizontal: 32,
    minWidth: 220,
    alignItems: "center",
    justifyContent: "center"
  },
  buttonText: {
    color: "#ffffff",
    fontWeight: "700",
    fontSize: 16
  }
})

/** @typedef {object} RoutesEmbedWelcomeProps */
/** @typedef {object} RoutesEmbedWelcomeState */

/**
 * @extends {ShapeComponent<RoutesEmbedWelcomeProps, RoutesEmbedWelcomeState>}
 */
class RoutesEmbedWelcome extends ShapeComponent {
  render() {
    const {t} = useI18n({namespace: "js.routes.embed.welcome"})
    const homeUrl = `${env.API_URL || ""}/se`

    return (
      <View dataSet={this.rootDataSet ||= {class: "routes--embed--welcome"}} style={styles.rootContainer}>
        <View style={styles.contentContainer}>
          <View style={styles.contentBlock}>
            <PageContentsPresentation identifier="embed_signup_welcome_se" />
          </View>
          <View style={styles.buttonContainer}>
            <Link target="_blank" testID="open-home-button" to={homeUrl}>
              <View style={styles.button}>
                <Text style={styles.buttonText}>{t(".open_woof")}</Text>
              </View>
            </Link>
          </View>
        </View>
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesEmbedWelcome))
